import React, { FC, useCallback } from 'react';

import Icon, { IconTypes } from '@sendbird/uikit-react/ui/Icon';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';

import { ReactComponent as FilledFilter } from '@pharmaplan/common/assets/icons/searchIconGreen.svg';
import { ReactComponent as UnfilledFilter } from '@pharmaplan/common/assets/icons/searchIcon.svg';
import { ReactComponent as CloseFilter } from '@pharmaplan/common/assets/icons/close.svg';

import ThemeConstants from '../../../../../theme/ThemeConstants';

import styles from './styles';

interface IChatHeaderSearchStates {
  showDialog?: (() => void) | null;
  showSearch: boolean;
  searchText: string;
  onSearchClick: () => void;
}

const ChatHeaderSearchStates: FC<IChatHeaderSearchStates> = ({
  showDialog,
  showSearch,
  searchText,
  onSearchClick,
}) => {
  const SearchIcon = useCallback(() => {
    let filter = <UnfilledFilter />;

    if (showSearch) {
      filter = <CloseFilter fill={ThemeConstants.grey[800]} />;
    }

    if (searchText && !showSearch) {
      filter = <FilledFilter />;
    }

    return filter;
  }, [searchText, showSearch]);

  return (
    <Box sx={styles.container}>
      <IconButton sx={styles.searchContainer} onClick={onSearchClick}>
        <SearchIcon />
      </IconButton>

      {showDialog && (
        <Box onClick={showDialog} sx={styles.create}>
          <Icon type={IconTypes.CREATE} fillColor="PRIMARY" />
        </Box>
      )}
    </Box>
  );
};

export default ChatHeaderSearchStates;
